import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {addMessageBoxInfo} from '../../common/messageBox/actions/actions';

export const getProviderOrdersAuthorizationList = () => apiActionCreator({
  'endpoint': '/orders/providers/authorization',
  'authenticated': true,
  'types': [
    ActionTypes.GET_PROVIDER_ORDERS_AUTHORIZATION_LIST_REQUEST,
    [
      ActionTypes.GET_PROVIDER_ORDERS_AUTHORIZATION_LIST_SUCCESS,
    ],
    [
      ActionTypes.GET_PROVIDER_ORDERS_AUTHORIZATION_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const rejectProviderOrderAuthorization = (data) => apiActionCreator({
  'endpoint': '/orders/providers/authorization',
  'authenticated': true,
  'types': [
    ActionTypes.REJECT_PROVIDER_ORDER_AUTHORIZATION_REQUEST,
    [
      {
        'type': ActionTypes.REJECT_PROVIDER_ORDER_AUTHORIZATION_SUCCESS,
        'payload': data.orderCode,
      },
      addMessageBoxInfo('Pedido rechazado satisfactoriamente'),
    ],
    [
      ActionTypes.REJECT_PROVIDER_ORDER_AUTHORIZATION_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'DELETE',
  'contentType': 'application/json',
  'data': data,
});

export const authorizeProviderOrder = (data) => apiActionCreator({
  'endpoint': '/orders/providers/authorization',
  'authenticated': true,
  'types': [
    ActionTypes.AUTHORIZE_PROVIDER_ORDER_REQUEST,
    [
      {
        'type': ActionTypes.AUTHORIZE_PROVIDER_ORDER_SUCCESS,
        'payload': data.orderCode,
      },
      addMessageBoxInfo('Pedido autorizado satisfactoriamente'),
    ],
    [
      ActionTypes.AUTHORIZE_PROVIDER_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});
